import React from "react";
import axios from "axios";
import { useState, useEffect, useMemo } from "react";
import MaterialReactTable from "material-react-table";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faPencil,  faTrashAlt } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';

const Designation = () => {
  const [value, setvalue] = useState("");
  const [designationData, setDesignationData] = useState([]);
  const [flag, setFlag] = useState(false);
  const [designationValue, setDesignationValue] = useState("");
  const [designationShortValue, setDesignationShortValue] = useState("");
  const [deleteCode, setDeleteCode] = useState({});
  const [editCode, setEditCode] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const result = await axios(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/designation`
    );
    setDesignationData(result.data.dataContent);
  };

  useEffect(() => {
    if (flag === true) {
      fetchData();
    }
  }, [flag]);

  const columns = useMemo(
    () => [
      {
        header: "S.No",
        Cell: (cell) => Number(cell.row.id) + 1,
      },
      {
        accessorKey: "desigName",
        header: "Designation Name",
      },
      {
        accessorKey: "desigShortName",
        header: "Designation Short Name",
      },
      {
        accessorKey: "visibility",
        header: "Visibility",
      },
      {
        accessor: "",
        header: "Actions",
        Cell: (cell) => (
          <>
            <i
              className="btn text-primary"
              type="button"
              onClick={() => handleEditDesignation(cell.row.original)}
            >
              <FontAwesomeIcon icon={faPencil} />
            </i>
            <i
              className="btn text-danger"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#myDelete"
              onClick={() =>
                setDeleteCode({
                    desigCode: cell.row.original.desigCode,
                })
              }
            >
              {" "}
              <FontAwesomeIcon icon={faTrashAlt} />
            </i>
          </>
        ),
      },
    ],
    []
  );

  function removed() {
    var mpopup = document.getElementById("mpopupBox");
    mpopup.style.display = "none";
    setDesignationValue("");
    setDesignationShortValue("");
  }
  function removedAdd() {
    var mpopup = document.getElementById("AddNewDesignation");
    mpopup.style.display = "none";
    setDesignationValue("");
    setDesignationShortValue("");
  }

  function handleEditDesignation(value) {
    document.getElementById("designationEdit").value = value.desigName;
    document.getElementById("designationShortEdit").value = value.desigShortName;

    // localUserTypeName = value.userTypeName
    // document.getElementById("userTypeEdit").defaultValue= ""
    // document.getElementById("userTypeEdit").defaultValue = value.userTypeName;
    setEditCode({
      "desigCode":  value.desigCode,
      "visibility": value.visibility
    
    });

    
    setDesignationValue(document.getElementById("designationEdit").value)
    setDesignationShortValue(document.getElementById("designationShortEdit").value)

    //   setUserTypeValue(value.seasonName)
    var x = document.createElement("a");
    x.id = "mpopupLink";
    var mpopup = document.getElementById("mpopupBox");
    mpopup.style.display = "block";
  }

  function AddNewDesignation() {
    if (designationValue && designationShortValue) {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        createdByUC: localStorage.getItem("userCodeGlobal"),
        desigName: designationValue,
        desigShortName: designationShortValue,
        sortingOrder: 1
      
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/designation`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          alert(JSON.parse(result).message);
          //   $('#addNewBtn').on('click', function () {
          // $('#addNewUserType').modal('hide');
          //  })
          if (JSON.parse(result).success === true) {
            // $('#addNewBtn').on('click', function () {
            // $('#addNewUserType').modal('hide');
            // })

            setFlag(true);
            setDesignationValue("");
            setDesignationShortValue("");
            removedAdd()
          }
        })
        .catch((error) => console.log("error", error));
    } else {
      alert("Enter All Fields");
    }
  }

  function deleteData(value) {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify(deleteCode);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/designation`, requestOptions)
        .then(response => response.text())
        .then(result => {
            if (JSON.parse(result).success === true) {
                fetchData()

            }
        })
        .catch(error => console.log('error', error));
}

function EditDesignation() {
    if (designationValue && designationShortValue) {
       
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({  

        "desigCode": editCode.desigCode,
        "modifiedByUC": localStorage.getItem("userCodeGlobal"),
        "desigName": designationValue,
        "desigShortName": designationShortValue,
        "sortingOrder": 1,
        "visibility": editCode.visibility
    
    });

    var requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/designation`, requestOptions)
        .then(response => response.text())
        .then(result => {
            alert(JSON.parse(result).message)
            if (JSON.parse(result).success === true) {
                setDesignationValue("")
                setDesignationShortValue("")
                fetchData()
                removed()


            }
        }
        )
        .catch(error => console.log('error', error));
    } else {
        alert("Enter All Fields");
      }
       
}

function handleDesignationValue(value) {
    const valueFinal = value.replace(/[^a-z0-9 ]/gi, "");
    document.getElementById("designationEdit").value = valueFinal;
    setDesignationValue(valueFinal)
}

function handleDesignationShortValue(value) {
    const valueFinal = value.replace(/[^a-z0-9 ]/gi, "");
    document.getElementById("designationShortEdit").value = valueFinal;
    setDesignationShortValue(valueFinal)
}

function handleAddNewData() {
    setDesignationValue("");
    setDesignationShortValue("");
    setFlag(false)
}

  return (
    <>
      <main id="main" className="main">
      <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
         
          <nav>
          <h1>Designation</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Master</li>
              <li className="breadcrumb-item active">Designation</li>
            </ol>
          </nav>
          <button
            type="button"
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target="#AddNewDesignation"
            onClick={() => handleAddNewData()}
          >
            Add New
          </button>
        </div>
        <section className="section">
          <div className="row justify-content-lg-center">
            <div className="col-lg-12 ">
              <div className="card">
                <MaterialReactTable
                  columns={columns}
                  data={designationData}
                  enableColumnOrdering
                  enablePagination={true}
                />
              </div>
            </div>

            <div className="col-lg-6"></div>
          </div>
          <div className="modal" id="AddNewDesignation">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                <label for="add_season" className="form-label">
                    Add New Designation
                  </label>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  >
                    X
                  </button>
                </div>

                <div className="modal-body">
                <label for="add_season" className="form-label">
                     Designation Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Designation Name"
                    onChange={(e) => handleDesignationValue(e.target.value)}
                    value={designationValue}
                    maxLength={50}
                  />
                  <br/>
                  <label for="add_season" className="form-label">
                     Designation Short Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Designation Short Name "
                    onChange={(e) => handleDesignationShortValue(e.target.value)}
                    value={designationShortValue}
                    maxLength={50}
                  />
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-success"
                    id="addNewBtn"
                    // data-bs-dismiss="modal"
                    onClick={AddNewDesignation}
                  >
                    Add
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div id="mpopupBox" className="modal">
            <div className="modal-content">
              <div className="modal-header">
              <label for="edit_season" className="form-label">
                  Edit Designation
                </label>
              </div>
              <div className="madal-body" id="modal-content">
              <label for="add_season" className="form-label">
                     Designation Name
                  </label>
                <input
                  type="text"
                  className="form-control"
                  id="designationEdit"
                  placeholder=""
                  onChange={(e) => handleDesignationValue(e.target.value)}
                  maxLength={50}
                />
                <br/>
                <label for="add_season" className="form-label">
                     Designation Short Name
                  </label>
                <input
                  type="text"
                  className="form-control"
                  id="designationShortEdit"
                  placeholder=""
                  onChange={(e) => handleDesignationShortValue(e.target.value)}
                  maxLength={50}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  data-bs-dismiss="modal"
                  onClick={EditDesignation}
                >
                  Add
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={removed}
                >
                  Close
                </button>
              </div>
            </div>
          </div>

          <div className="modal" id="myDelete">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  >
                    X
                  </button>
                </div>

                <div className="modal-body">
                  <p>Are you sure you want to delete this item?</p>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-success"
                    data-bs-dismiss="modal"
                    onClick={deleteData}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Designation;
